import { LitElement, html, PropertyValues } from 'lit';
import { customElement, query, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { translateFn } from '../../../../../utils/translator.helper';
import { FormGroup } from 'apps/webcomponents/src/ui/gzForm/formGroup/form-group';
import { GzFormFieldWebComponent } from '../../../../../ui/gzForm/formField';
import { GzCheckboxWebComponent } from '../../../../../ui/gzCheckbox';
import { FormGroupValue } from '../../../../../ui/gzForm/formGroup/types/form-group-value';

/**
 * @summary This component is used for displaying the content of the uninstall agent pop-up
 * @tag gz-uninstall-agent
 */
@customElement('gz-uninstall-agent')
export class GzUninstallAgentWebComponent extends LitElement {
  static get styles() {
    return styles;
  }

  @query('#keep-quarantined-items-checkbox')
  private checkbox: GzFormFieldWebComponent<GzCheckboxWebComponent>;

  @state()
  private formGroup: FormGroup;

  protected firstUpdated(_changedProperties: PropertyValues) {
    super.firstUpdated(_changedProperties);
    this.buildFormGroup();
  }

  public getFormValue(): FormGroupValue {
    return this.formGroup.value;
  }

  private buildFormGroup(): void {
    this.formGroup = FormGroup.build({
      keepQuarantinedItemsCheckbox: this.checkbox,
    });
  }

  public detachFormEventListeners(): void {
    this.formGroup.unsubscribe();
  }

  render() {
    return html`
      <gz-text fontSize="14"
        >${translateFn('You are about to uninstall the security agent from the selected endpoints.')}</gz-text
      >
      <gz-form-field id="keep-quarantined-items-checkbox" class="form-field">
        <gz-checkbox gz-form-input label="${translateFn('Keep quarantined items on the endpoint')}"></gz-checkbox>
      </gz-form-field>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-uninstall-agent': GzUninstallAgentWebComponent;
  }
}
